import React, { useEffect, useState } from "react";
import { Modal, Spin } from "antd";
import dayjs from "dayjs";
import { Method_POST_CONTEXTO } from "../../../../service/api";
import { useDraggableModal } from "../Balancete/utils/modalDraggable";

export default function DreModal({ title, visible, filterType, mesCompetencia, periodo, onClose, zIndex, onFocus }) {
  const draggableProps = useDraggableModal(zIndex, onFocus, {
    top: 20,
    initialWidth: 1200,
    initialHeight: 820,
    modalKey: 'dre',
    visible: visible
  });
  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (visible && !url) {
      generateDRE(false);
    }
  }, [visible, url]);

  const generateDRE = async (assinado) => {
    setLoading(true);

    let dataInicio, dataTermino;
    const storedMes = sessionStorage.getItem("mesCompetencia");
    const storedPeriodo = sessionStorage.getItem("periodo");

    if (filterType === "mensal") {
      const mes = storedMes ? dayjs(storedMes) : mesCompetencia;
      dataInicio = mes.startOf("month").hour(12).toISOString();
      dataTermino = mes.endOf("month").hour(12).toISOString();
    } else {
      const period = storedPeriodo
        ? JSON.parse(storedPeriodo).map(d => dayjs(d))
        : periodo;
      dataInicio = period[0].startOf("month").hour(12).toISOString();
      dataTermino = period[1].endOf("month").hour(12).toISOString();
    }

    let clienteId = sessionStorage.getItem("COMPANY") ? JSON.parse(sessionStorage.getItem("COMPANY"))?.id : 110;

    const payload = { dataInicio, dataTermino, cliente: { id: clienteId } };

    try {
      const res = await Method_POST_CONTEXTO(
        `/empresa/contabilidade/create/temporary/dre?assinado=${assinado}`,
        payload,
        { responseType: "text" }
      );
      const base64Url = `data:application/pdf;base64,${res}`;
      setUrl(base64Url);
    } catch (err) {
      console.error("Erro ao gerar DRE:", err);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    onClose?.();
    if (url) {
      window.URL.revokeObjectURL(url);
      setUrl("");
    }
  };

  return (
    <Modal
      title={title || "DRE - Demonstração de Resultado do Exercício"}
      open={visible}
      onCancel={onClose}
      width="100%"
      className="premium-modal-v2"
      footer={null}
      {...draggableProps}
      styles={{
        content: {
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        },
        body: {
          flex: 1,
          padding: 0,
          overflow: "hidden",
          background: '#525659',
          height: '80vh'
        }
      }}
    >
      {loading && (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", background: '#525659' }}>
          <Spin size="large" />
        </div>
      )}
      {!loading && url && (
        <iframe
          key={url}
          src={url + "#zoom=80"}
          title="DRE PDF"
          width="100%"
          height="100%"
          style={{ border: "none", display: 'block' }}
        />
      )}
    </Modal>
  );
}
